export const DEFAULT_URL = 'http://data.fixer.io/api';
